import { type ClientPortalCaseData } from '@/lib/queries/case-dashboard/types'
import { useClientPortalInternalSampleStore } from '@/lib/stores/client-portal-internal-sample-store'

export const useClientPortalInternalSampleContent = () => {
  const { currentCase } = useClientPortalInternalSampleStore()

  const caseData: ClientPortalCaseData = {
    caseId: currentCase.caseId,
    caseNumber: currentCase.caseNumber,
    caseType: currentCase.caseType,
    applicationType: currentCase.applicationType,
    applicationFiledDate: currentCase.applicationFiledDate,
    lastStatus: currentCase.lastStatus,
    priorityDate: currentCase.priorityDate,
    serviceCenter: currentCase.serviceCenter,
  }
  const companyData = currentCase.company
  const historyData = currentCase.history
  const portalOptions = currentCase.portalOptions

  return { caseData, companyData, historyData, portalOptions }
}
